export class MenuPermissionEditModel{
    permissions:MenuPermissionEditModels;
}
export class MenuPermissionEditModels{
    menuId:number;
    roleIds:number[];
}